import { DateTime } from 'luxon';

// Selectors for member-related data
export const getMembersById = (state) => state.member.members_by_id;

export const getShifts = (state) => {
  const shifts = state.member.shifts;
  const originalShifts = state.member.original_shifts;

  // Deep copy shifts
  const shiftsCopy = JSON.parse(JSON.stringify(shifts, (key, value) => {
    // Handle DateTime objects during stringification
    if (value && typeof value === 'object' && value.isLuxonDateTime) {
      return value.toISO();
    }
    return value;
  }));

  // Convert DateTime objects to ISO format
  const toISO = (value) => {
    if (!value) return null;

    return (value instanceof DateTime ? value : DateTime.fromISO(value)).toISO();
  };

  const exportShifts = shiftsCopy.map(shift => ({
    ...shift,
    start_time: toISO(shift.start_time),
    end_time: toISO(shift.end_time),
    lunch: toISO(shift.lunch),
    dinner: toISO(shift.dinner),
  }));

  // Remove duplicates by identifier (ugly hotfix for inexplicable duplicates)
  const uniqueShifts = exportShifts.reduce((acc, shift) => {
    if (!acc.find(s => s.identifier === shift.identifier)) {
      acc.push(shift);
    }
    return acc;
  }, []);

  // Mark removed members with _destroy flag
  uniqueShifts.forEach(shift => {
    // There are no original shifts for new shifts
    const originalShift = originalShifts.find(os => os.identifier === shift.identifier);
    if (!originalShift) {
      return;
    }

    // Index current shift members by id
    const shiftMembersById = shift.members.reduce((acc, member) => {
      acc[member.id] = member;
      return acc;
    }, {});

    // Check each original member
    originalShift.members.forEach(member => {
      if (!shiftMembersById[member.id]) {
        // Member was removed, add with _destroy flag
        shift.members.push({
          ...member,
          _destroy: "1"
        });
      }
    });

  });

  const returnShifts = Object.assign({},
          uniqueShifts.map(shift => (
              {
                ...shift,
                members: Object.assign({}, shift.members)
              }
            )
          )
        );

  return returnShifts;
};

export const getPeriods = (state) => state.member.periods;

export const getLoading = (state) => state.member.loading;

export const getDisplayGlobal = (state) => state.member.display_global;

export const getHideMembersWithEnoughShiftsHours = (state) =>
  state.member.hide_members_with_enough_shifts_hours;

export const getHiddenCount = (state) =>
  state.member.count_of_hidden_members_with_enough_shifts_hours;

export const getFilters = (state) => state.member.filters;

// Calculate shift count for a member
export const getMemberShiftsCount = (member, displayGlobal) => {
  if (displayGlobal) {
    return member.total_shift_count || 0;
  }
  return member.current_shift_count || 0;
};

// Calculate hour count for a member
export const getMemberHoursCount = (member, displayGlobal) => {
  if (displayGlobal) {
    return member.total_hour_count || 0;
  }
  return member.current_hour_count || 0;
};

// Check if member has enough shift hours
export const hasEnoughShiftHours = (member) => {
  const totalHours = member.total_hour_count || 0;
  const minimumHours = member.minimum_shift_hours || 0;
  const maximumHours = member.maximum_shift_hours || 0;
  
  if (maximumHours > 0) {
    return totalHours >= minimumHours && totalHours <= maximumHours;
  } else {
    return totalHours >= minimumHours;
  }
};

// Get full member info by merging member data with members_by_id
export const getMemberWithFullInfo = (member, membersById) => {
  return { ...member, ...membersById[member.id] };
};
